import React from 'react';
import DarkFaqAccess from '../assets/icons/dark-faq-access';
import DarkFaqCertification from '../assets/icons/dark-faq-certification';
import DarkFaqClassGroups from '../assets/icons/dark-faq-class-groups';
import DarkFaqCommunity from '../assets/icons/dark-faq-community';
import DarkFaqExercises from '../assets/icons/dark-faq-exercises';
import DarkFaqFrequentlyQuestions from '../assets/icons/dark-faq-frequently-questions';
import DarkFaqPlatform from '../assets/icons/dark-faq-platform';
import DarkFaqProjects from '../assets/icons/dark-faq-projects';
import DarkFaqSupport from '../assets/icons/dark-faq-support';
import FaqAccess from '../assets/icons/faq-access';
import FaqCertification from '../assets/icons/faq-certification';
import FaqClassGroups from '../assets/icons/faq-class-groups';
import FaqCommunity from '../assets/icons/faq-community';
import FaqExercises from '../assets/icons/faq-exercises';
import FaqFrequentlyQuestions from '../assets/icons/faq-frequently-questions';
import FaqPlatform from '../assets/icons/faq-platform';
import FaqProjects from '../assets/icons/faq-projects';
import FaqSupport from '../assets/icons/faq-support';

type IconProps = JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>;

type IconComponent = React.FC<IconProps>;

const iconMap: Record<string, IconComponent> = {
  access: FaqAccess,
  platform: FaqPlatform,
  certification: FaqCertification,
  projects: FaqProjects,
  classGroups: FaqClassGroups,
  support: FaqSupport,
  exercises: FaqExercises,
  community: FaqCommunity,
  frequentlyQuestions: FaqFrequentlyQuestions
};

const darkIconMap: Record<string, IconComponent> = {
  access: DarkFaqAccess,
  platform: DarkFaqPlatform,
  certification: DarkFaqCertification,
  projects: DarkFaqProjects,
  classGroups: DarkFaqClassGroups,
  support: DarkFaqSupport,
  exercises: DarkFaqExercises,
  community: DarkFaqCommunity,
  frequentlyQuestions: DarkFaqFrequentlyQuestions
};

export const getFaqCategoryIcon = (
  slug: string,
  isDark = false
): IconComponent | null => {
  const map = isDark ? darkIconMap : iconMap;
  return map[slug] || null;
};

export default getFaqCategoryIcon;
